// ============================================================
// LAB TEST PROVIDER LINKS — single source of truth
// ============================================================
// Currently using plain (non-affiliate) public product URLs.
// When affiliate programs are approved post-launch, swap each
// `url` value here for the affiliate URL and the change will
// take effect everywhere.
//
// DO NOT change the keys / shape — UI consumers depend on them.
// ============================================================

export type LabProvider = {
  id: "everlywell" | "labcorp" | "questhealth";
  name: string;
  product: string;
  blurb: string;
  url: string;
};

export const LAB_PROVIDERS: LabProvider[] = [
  {
    id: "everlywell",
    name: "Everlywell",
    product: "Women's Health Test",
    blurb: "At-home blood spot kit covering 11 key hormones — including estradiol, FSH, LH, progesterone, and TSH.",
    url: "https://www.everlywell.com/products/womens-health-test/",
  },
  {
    id: "labcorp",
    name: "Labcorp OnDemand",
    product: "Menopause Test",
    blurb: "Clinical-lab menopause panel measuring FSH and estradiol — order online, draw at a Labcorp location.",
    url: "https://www.ondemand.labcorp.com/lab-tests/menopause-test",
  },
  {
    id: "questhealth",
    name: "Quest Health",
    product: "Menopause & Perimenopause Assessment",
    blurb: "Quest Diagnostics panel covering estradiol, FSH, LH, and TSH to help assess menopause status.",
    url: "https://www.questhealth.com/product/menopause-perimenopause-assessment-test-panel/12570M.html",
  },
];

export const LAB_PROVIDER_DISCLAIMER =
  "KnowMeno is not affiliated with these providers. Always consult your doctor about which tests are right for you.";
